// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum READER_PARAMS_TYPE {
    zoom = 'zoom',
    page = 'page',
    section = 'section',
    chapterId = 'chapterId',
    sectionId = 'sectionId',
    openBuyOptions = 'openBuyOptions',
}
